/**
 * Curated emoji list for rich text status indicators.
 * Uses native Unicode emojis — no external emoji package required.
 */

export interface EmojiEntry {
  emoji: string;
  name: string;
}

export const EMOJI_LIST: EmojiEntry[] = [
  { emoji: '\u{2705}', name: 'check mark' },
  { emoji: '\u{274C}', name: 'cross mark' },
  { emoji: '\u{26A0}\u{FE0F}', name: 'warning' },
  { emoji: '\u{1F6A8}', name: 'rotating light' },
  { emoji: '\u{1F6AB}', name: 'no entry' },
  { emoji: '\u{2757}', name: 'exclamation' }
];
